module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/fall-left-icon-6d581b7736b24d48e889ff07b0c01e1d.svg";